import {Component, OnInit} from '@angular/core';
import {HelpPageComponent} from '../../help-page.component';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../../../../../../environments/environment';

@Component({
    selector: 'app-help-page-link-costomer-portal',
    templateUrl: './help-page-link-costomer-portal.component.html',
    styleUrls: ['./help-page-link-costomer-portal.component.scss', '../../helpPageModule.scss'],
    standalone: false
})
export class HelpPageLinkCostomerPortalComponent extends HelpPageComponent implements OnInit
{
    urlLanguage: string;

    constructor(public translate: TranslateService)
    {
        super(translate);
    }

    ngOnInit(): void
    {
        this.urlLanguage = this.translate.currentLang;
    }
    public readonly environment = environment;
}
